import { observer } from 'mobx-react-lite';
import { FC, ReactElement, useEffect } from 'react';
import { Controller } from 'react-hook-form';

import { useTranslation } from '@gem/modules/i18n';
import { Button, ButtonTypes, TextField } from '@gem/ui-kit';

import { BackButton } from '../../Pages/Components/BackButton/BackButton';
import { ISetView } from '../CallInvitation.types';
import { INameBlockFormData, useNameBlockPresenter } from './NameBlock.presenter';
import styles from './NameBlock.styles.m.css';
import { nameValidation } from './validation/nameValidation';

interface INameBlockProps {
  setView: ISetView;
}

export const NameBlock: FC<INameBlockProps> = observer(({ setView }) => {
  const { t } = useTranslation();
  const { presenter, form } = useNameBlockPresenter(setView);

  useEffect(() => {
    form.setFocus('name');
  }, [form.setFocus]);

  return (
    <div className={styles.container}>
      <BackButton goBack={presenter.goBack} />
      <h1 className={styles.subTitle}>{t('call_invitation_guest_name_header')}</h1>
      <form
        className={styles.form}
        onSubmit={form.handleSubmit(presenter.onSubmit)}
      >
        <Controller
          control={form.control}
          name="name"
          rules={nameValidation<INameBlockFormData>(
            t('call_invitation_guest_name_min_length_error')
          )}
          render={({ field, fieldState }): ReactElement => {
            return (
              <TextField
                label={t('username')}
                {...field}
                className={styles.username}
                classNameContent={styles.inputContent}
                hasError={fieldState.invalid}
                message={fieldState.error?.message || ' '}
              />
            );
          }}
        />

        <div className={styles.footer}>
          <Button
            size="20"
            type={ButtonTypes.Submit}
            theme="primary"
            isLoading={form.formState.isSubmitting}
            isDisabled={!form.formState.isDirty}
          >
            {t('common_done')}
          </Button>
        </div>
      </form>
    </div>
  );
});
